<template>
  <div id="container" class="gnb_pdt">
    <div class="title_wrap"><h1>접속기록통계</h1></div>

    <!-- 검색 영역 -->
    <common-area-search
        :row="4"
        :colspan="2"
        @search="allApiCall"
        @clear="cleanSearchDataEvent"
    >
      <template v-slot:R1_C1>
        <label>회사명</label>
        <ul>
          <common-multi-drop-down
              ref="cmpyCdRef"
              @change="value=>{
                  propsCmpyCd = value
                  allApiCall()
                }"
              :params="{ 'sort[0].dir': 'asc', 'sort[0].field': 'cmpyNm', searchCmpyGbnGrup : [Constant.efs.cmpyGbn.CLIENT_COMPANY] }"
              :default-index="0"
              :data-columns="[{ field: 'cmpyNm', title: '회사명', width: '60%' },{ field: 'cmpyCd', title: '회사코드', width: '40%' }]"
              :url="`${ApiConfig.efsDomain}/efs/drop-down/company`"
              :data-value-field="'cmpyCd'"
              :data-text-field="'cmpyNm'"
          >
          </common-multi-drop-down>
        </ul>
      </template>
      <template v-slot:R1_C2>
        <label>조회기간</label>
        <ul>
          <common-range-datepicker
              ref="dtRef"
              :range="{ start : defaultStartDate, end : new Date() }"
              @change="allApiCall"
          >
          </common-range-datepicker>
        </ul>
      </template>
      <!--
        아래 검색조건은 요약 카드 / 일별 추이 / 목록에 모두 같이 적용된다.
        (통계 API 도 목록 API 와 동일한 조건을 받는다. 한쪽만 필터가 걸리면
         차트와 목록의 건수가 어긋나 보여 통계를 신뢰할 수 없게 된다.)
      -->
      <template v-slot:R2_C1>
        <label>계정</label>
        <ul>
          <input
              ref="userTextRef"
              class="k-textbox w100"
              placeholder="계정ID(이메일), 사용자명으로 검색"
              @keyup.enter="allApiCall"
          />
        </ul>
      </template>
      <template v-slot:R2_C2>
        <label>수행업무</label>
        <ul>
          <kendo-dropdownlist
              ref="taskTypeRef"
              style="width: 100%"
              :data-source="taskTypeList"
              :data-text-field="'cdNm'"
              :data-value-field="'cdId'"
              :option-label="'전체'"
              @change="allApiCall"
          >
          </kendo-dropdownlist>
        </ul>
      </template>
      <template v-slot:R3_C1>
        <label>접속 IP</label>
        <ul>
          <input
              ref="acsIpRef"
              class="k-textbox w100"
              placeholder="부분 입력 가능 (예: 192.168.)"
              @keyup.enter="allApiCall"
          />
        </ul>
      </template>
      <template v-slot:R3_C2>
        <label>요청 URI</label>
        <ul>
          <input
              ref="reqUriRef"
              class="k-textbox w100"
              placeholder="부분 입력 가능 (예: /fms/goods)"
              @keyup.enter="allApiCall"
          />
        </ul>
      </template>
      <template v-slot:R4_C1>
        <label>처리결과</label>
        <ul>
          <common-button-group
              ref="errYnRef"
              :style="'width: 100%; border: 0;'"
              :data-items="[{ text: '전체', value: '' },{ text: '정상만', value: 'N' },{ text: '오류만', value: 'Y' }]"
              @click="onClickErrYnGroup"
          >
          </common-button-group>
        </ul>
      </template>
    </common-area-search>
    <!-- //검색 영역 -->

    <!-- 요약 카드 -->
    <!--
      너비 클래스를 주지 않고 box_flex 의 균등 분배에 맡긴다.
      w20 을 5개 나열하면 카드 사이 여백까지 더해져 한 줄을 넘긴다.
      (기존 통계화면 ReportLocationList 의 상단 3분할과 동일한 방식)
    -->
    <div class="box_flex">
      <div v-for="card in summaryCardList"
           :key="card.key"
           class="contents_wrap mgt10">
        <div class="small_title_wrap w100">
          <h2>{{ card.title }}</h2>
        </div>
        <p class="acs_stat_value" :class="card.tone">
          {{ card.value }}<span class="acs_stat_unit">{{ card.unit }}</span>
        </p>
        <p class="acs_stat_desc">{{ card.desc }}</p>
      </div>
    </div>

    <!-- 일별 접속 추이 -->
    <div class="contents_wrap mgt10">
      <div class="small_title_wrap w100">
        <h2>
          일별 접속 추이
          <span class="acs_stat_period">집계기간 {{ appliedPeriodText }}</span>
          <span class="acs_stat_period">막대나 꼭지점을 클릭하면 아래 목록이 그 날짜만 조회됩니다.</span>
        </h2>
      </div>
      <kendo-chart :render-as="'canvas'"
                   :chart-area="{background : '', height:330, margin: { top : 10, left : 0, right :0, bottom:10 }}"
                   :legend-item-click="onClickLegend"
                   :series-click="onClickChartSeries"
                   :pannable-lock="'y'"
                   :transitions="chartTransitions"
                   :series="[
                        {
                          type: totalChartData.series.type,
                          data: totalChartData.series.data,
                          axis: totalChartData.series.axis,
                          visible : totalChartData.series.visible,
                          categoryField: totalChartData.series.categoryField,
                          name: constant.total,
                          field : totalChartData.series.field,
                          color: totalChartData.series.color,
                          tooltip : totalChartData.series.tooltip
                        },
                        {
                          type: loginChartData.series.type,
                          data: loginChartData.series.data,
                          axis: loginChartData.series.axis,
                          visible : loginChartData.series.visible,
                          categoryField: loginChartData.series.categoryField,
                          name: constant.login,
                          field : loginChartData.series.field,
                          color: loginChartData.series.color,
                          tooltip : loginChartData.series.tooltip
                        }]"
                   :category-axis="{
                        justified: true,
                        axisCrossingValues: [0, 999],
                      }"
                   :value-axis="[
                        totalChartData.valueAxis,
                        loginChartData.valueAxis
                      ]"
                   :legend="{
                        visible : true,
                        position : 'top',
                      }"
                   :theme="'sass'">
      </kendo-chart>
    </div>

    <!-- 접속기록 목록 -->
    <section class="mgt10">
      <div class="contents_top_sec">
        <div class="c_t_button_wrap fl">
          <span class="acs_list_scope">조회대상 {{ listScopeText }}</span>
          <button v-if="selectedYmd"
                  class="mid_btn"
                  style="margin-left: 5px;"
                  @click="onClickClearSelectedDay">
            선택일 해제
          </button>
        </div>
        <div class="c_t_button_wrap fr">
          <button class="mid_btn" @click="onClickExcelDownload"><i class="download_icon"></i>엑셀 다운로드</button>
        </div>
      </div>

      <div class="content_list">
        <!-- Kendo 영역 -->
        <!--
          auto-bind 을 끈 이유 : 목록 API 는 linkCmpyCd 가 필수값이다.
          회사 드롭다운이 값을 채우기 전에 그리드가 스스로 조회하면 400 이 떨어진다.
        -->
        <kendo-grid ref="gridRef"
                    :data-source="computedAcsLogGridRows"
                    :auto-bind="false"
                    :navigatable="false"
                    :sortable-mode="'multiple'"
                    :pageable-page-sizes="[10, 20, 50, 100, 500]"
                    :reorderable="true"
                    :column-menu="false"
                    :resizable="true"
                    :selectable="'row'"
                    :columns="gridColumns"
                    :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }"
        />
        <!-- Kendo 영역 끝 -->
      </div>
    </section>
  </div>
</template>

<script>
import EtnersCommonUtil from '@ebmp-fe-common-module/module/src/common/etners.common.util'
import EtnersDateTimeUtil from '@ebmp-fe-common-module/module/src/common/etners.datetime.util'
import EtnersEfsUtil from '@/common/etners.efs.util'
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'
import Constant from '@/common/constant'
import { saveExcel } from '@progress/kendo-vue-excel-export'

export default {
  name: 'ReportAcsLogList',
  computed: {
    /**
     * 접속기록 목록 그리드. 서버 페이징으로 붙인다.
     * FMS_ACS_LOG 는 API 호출마다 1행씩 쌓이는 테이블이라 전체를 받아 클라이언트에서
     * 나눌 수 없다. 정렬도 서버에 맡긴다.
     */
    computedAcsLogGridRows: function () {
      const vm = this

      return new kendo.data.DataSource({
        name: 'gridDataSource',
        page: 1,
        pageSize: 10,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.fmsDomain}/fms/common/acs-log`,
            type: 'GET',
            contentType: 'application/json',
            cache: false,
          },
          parameterMap: function (options, operation) {

            if (operation === 'read') {

              const sort = EtnersEfsUtil.convertJSONArrayToJSON('sort', options.sort)

              vm.lastListParams = {
                loginUserToken: vm.$store.state.loginStore.lutk,
                skip: options.skip,
                take: options.take,
                page: options.page,
                pageSize: options.pageSize,
                ...sort,
                ...vm.listFilterParam()
              }

              return vm.lastListParams
            }
          },
        },
        // 회사를 고르지 않으면 조회할 대상 자체가 없다.
        // linkCmpyCd 없이 요청하면 서버 검증에서 걸리므로 아예 보내지 않는다.
        requestStart: function (e) {
          if (!vm.propsCmpyCd) {
            e.preventDefault()
          }
        },
        schema: {
          type: 'json',
          parse: function (response) {
            const changeResultData = response.resultData
            let rowNumber = (vm.$refs.gridRef.dataSource.page() - 1)
                * vm.$refs.gridRef.dataSource.pageSize()

            for (let i = 0; i < changeResultData?.length; i++) {
              changeResultData[i].rowNumber = response.total - rowNumber++
            }

            response.resultData = changeResultData
            return response
          },
          total: function (response) {
            return response.total
          },
          data: function (response) {
            if (response.resultStatus.messageCode === '2000') {
              return response.resultData
            }

            // 4042 : 조회 대상 없음. 통계 화면과 같이 경고 없이 빈 목록으로 둔다.
            if (response.resultStatus.messageCode === '4042') {
              return []
            }

            if (response.resultStatus.messageCode === '4154') {
              vm.$store.dispatch('LOGOUT').then(() => {
                kendo.alert(response.resultStatus.messageText).bind('close', function () {
                  window.location.href = `/login`
                })
              })
              return []
            }

            kendo.alert(response.resultStatus.messageText)
            return []
          },
        },
        error: function (e) {
          console.log('error event handler', e.errors[0])
        },
      })
    },
    /**
     * 목록이 실제로 무엇을 담고 있는지 표기한다.
     * 차트에서 하루를 골랐을 때 목록만 좁혀지므로, 좁혀진 상태가 화면에 드러나야 한다.
     */
    listScopeText: function () {
      const vm = this

      if (vm.selectedYmd) {
        return `${vm.toDisplayDate(vm.selectedYmd)} (차트에서 선택한 일자)`
      }

      return vm.appliedPeriodText
    },
    /**
     * 서버가 실제 적용한 집계기간. 기간을 비워 조회했거나 상한(366일)을 넘겨
     * 서버가 기간을 좁힌 경우에도 무엇이 집계되었는지 화면에서 드러나야 한다.
     */
    appliedPeriodText: function () {
      const vm = this

      if (!vm.stats.searchStartYYYYMMDD || !vm.stats.searchEndYYYYMMDD) {
        return '-'
      }

      return `${vm.toDisplayDate(vm.stats.searchStartYYYYMMDD)} ~ ${vm.toDisplayDate(vm.stats.searchEndYYYYMMDD)}`
    },
    summaryCardList: function () {
      const vm = this
      const comma = EtnersCommonUtil.numberWithCommas

      return [
        {
          key: 'totalCnt',
          title: '총 접속건수',
          value: comma(vm.stats.totalCnt),
          unit: '건',
          tone: 'blue',
          desc: '기간 내 기록된 전체 접속기록'
        },
        {
          key: 'userCnt',
          title: '접속 사용자수',
          value: comma(vm.stats.userCnt),
          unit: '명',
          tone: 'blue',
          desc: '중복 제외 고유 계정 수'
        },
        {
          key: 'loginCnt',
          title: '로그인 건수',
          value: comma(vm.stats.loginCnt),
          unit: '건',
          tone: 'green',
          desc: '수행업무가 로그인인 기록'
        },
        {
          key: 'errCnt',
          title: '오류 건수',
          value: comma(vm.stats.errCnt),
          unit: '건',
          tone: vm.stats.errCnt > 0 ? 'red' : 'gray',
          desc: '처리 중 오류가 발생한 요청'
        },
        {
          key: 'avgProcMs',
          title: '평균 처리시간',
          value: comma(vm.stats.avgProcMs),
          unit: 'ms',
          tone: 'gray',
          desc: '요청 1건당 평균 소요시간'
        }
      ]
    }
  },
  methods: {
    toDisplayDate: function (yyyymmdd) {
      if (!yyyymmdd || yyyymmdd.length !== 8) {
        return '-'
      }

      return `${yyyymmdd.substr(0, 4)}/${yyyymmdd.substr(4, 2)}/${yyyymmdd.substr(6, 2)}`
    },
    /**
     * 계열 토글. 숨긴 계열의 값축은 회색으로 눌러 어느 축이 죽었는지 보이게 한다.
     * (기존 통계화면 ReportLocationList 와 동일한 동작)
     */
    onClickLegend: function (e) {
      const vm = this
      vm.chartTransitions = false

      if (e.series.axis === vm.constant.totalAxis) {
        vm.totalChartData.series.visible = !vm.totalChartData.series.visible
        vm.$set(vm.totalChartData.valueAxis, 'color', vm.totalChartData.series.visible ? '' : '#d0d0d0')
      } else {
        vm.loginChartData.series.visible = !vm.loginChartData.series.visible
        vm.$set(vm.loginChartData.valueAxis, 'color', vm.loginChartData.series.visible ? '' : '#d0d0d0')
      }
    },
    searchFilterParam: function () {
      const vm = this
      const refs = vm.$refs

      if (!vm.propsCmpyCd) {
        return undefined
      }

      let searchFilterOptions = {
        // fms-api 는 진입 회사코드 기준으로 접속기록을 조회한다.
        // 다른 efs 화면(StkItemList 등)이 fms-api 를 호출할 때와 동일한 방식이다.
        linkCmpyCd: vm.propsCmpyCd
      }

      const range = refs.dtRef?.widget()?.range()

      if (range?.start) {
        searchFilterOptions.searchStartYYYYMMDD = EtnersDateTimeUtil.dateToYYYYMMDD(range.start)
      }

      if (range?.end) {
        searchFilterOptions.searchEndYYYYMMDD = EtnersDateTimeUtil.dateToYYYYMMDD(range.end)
      }

      const userText = refs.userTextRef?.value?.trim()
      if (userText) {
        searchFilterOptions.searchUserText = userText
      }

      const taskType = refs.taskTypeRef?.kendoWidget()?.value()
      if (taskType) {
        searchFilterOptions.searchTaskType = taskType
      }

      const acsIp = refs.acsIpRef?.value?.trim()
      if (acsIp) {
        searchFilterOptions.searchAcsIp = acsIp
      }

      const reqUri = refs.reqUriRef?.value?.trim()
      if (reqUri) {
        searchFilterOptions.searchReqUri = reqUri
      }

      const errYn = refs.errYnRef?.widget()?.value()
      if (errYn) {
        searchFilterOptions.searchErrYn = errYn
      }

      return searchFilterOptions
    },
    /**
     * 목록 조회조건. 검색영역 조건에 "차트에서 고른 일자" 만 덧붙인다.
     *
     * 기간을 비워둔 채 조회하면 서버가 최근 30일로 보정하는데, 그때 목록도 같은 기간을
     * 봐야 하므로 통계 응답이 돌려준 실제 적용기간을 기본값으로 쓴다.
     */
    listFilterParam: function () {
      const vm = this
      const param = vm.searchFilterParam()

      if (!param) {
        return undefined
      }

      if (vm.selectedYmd) {
        return {
          ...param,
          searchStartYYYYMMDD: vm.selectedYmd,
          searchEndYYYYMMDD: vm.selectedYmd
        }
      }

      return {
        ...param,
        searchStartYYYYMMDD: param.searchStartYYYYMMDD || vm.stats.searchStartYYYYMMDD || '',
        searchEndYYYYMMDD: param.searchEndYYYYMMDD || vm.stats.searchEndYYYYMMDD || ''
      }
    },
    /**
     * 목록을 1페이지부터 다시 읽는다. 조건이 바뀐 뒤 3페이지에 머물러 있으면
     * 빈 페이지를 보게 되므로 페이지를 되돌린다.
     */
    refreshList: function () {
      const vm = this
      const grid = vm.$refs.gridRef?.kendoWidget()

      if (!grid) {
        return
      }

      if (!vm.propsCmpyCd) {
        grid.dataSource.data([])
        return
      }

      grid.dataSource.query({
        sort: {},
        take: grid.dataSource.pageSize() ?? 10,
        page: 1,
        pageSize: grid.dataSource.pageSize() ?? 10,
      })
    },
    /**
     * 차트의 특정 일자를 클릭하면 목록만 그 하루로 좁힌다.
     * 차트(집계기간 전체)는 그대로 두어 "어느 날을 보고 있는지" 를 잃지 않게 한다.
     * 같은 일자를 다시 클릭하면 해제한다.
     */
    onClickChartSeries: function (e) {
      const vm = this
      const acsYmd = e?.dataItem?.acsYmd

      if (!acsYmd) {
        return
      }

      vm.selectedYmd = vm.selectedYmd === acsYmd ? '' : acsYmd
      vm.refreshList()
    },
    onClickClearSelectedDay: function () {
      const vm = this

      vm.selectedYmd = ''
      vm.refreshList()
    },
    /**
     * CommonButtonGroup 은 mounted 시점에 기본값으로 click 을 한 번 발생시킨다.
     * 그때는 아직 조회할 상태가 아니므로 흘려보낸다.
     */
    onClickErrYnGroup: function () {
      const vm = this

      if (!vm.isErrYnGroupMounted) {
        vm.isErrYnGroupMounted = true
        return
      }

      vm.allApiCall()
    },
    /**
     * 접속일시. 서버가 LocalDateTime 을 ISO 문자열(2026-09-17T13:24:05)로 내려주므로
     * 화면 표기 형식으로만 바꾼다.
     */
    toDisplayDateTime: function (value) {
      if (!value) {
        return '-'
      }

      return String(value).replace('T', ' ').substring(0, 19)
    },
    /**
     * 요청 파라미터 / User-Agent / 오류 메시지처럼 셀 폭을 넘기는 값은
     * 한 줄로 자르고 전체 내용은 tooltip 으로 보여준다.
     */
    cellWithTooltip: function (text, tooltip) {
      const value = text ?? ''

      if (!value) {
        return '-'
      }

      const title = kendo.htmlEncode(tooltip ?? value)

      return `<span title="${title}">${kendo.htmlEncode(value)}</span>`
    },
    allApiCall: function () {
      const vm = this
      const param = vm.searchFilterParam()

      // 회사를 고르지 않으면 조회할 대상 자체가 없다. 빈 화면으로 초기화만 한다.
      if (!param) {
        vm.resetStats()
        return
      }

      vm.chartTransitions = true

      // 검색조건이 바뀌면 차트에서 골라둔 일자는 더 이상 유효하지 않다.
      vm.selectedYmd = ''

      ApiUtil.query(`${ApiConfig.fmsDomain}/fms/common/acs-log/stats`, param)
      .then((response) => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터가 정상적으로 조회되지 않았습니다.')
          return false
        }

        // 4042 : 조회 대상 없음. 통계 화면에서는 경고 없이 빈 상태로 그린다.
        if (response.data.resultStatus.messageCode === '4042') {
          vm.resetStats()
          return false
        }

        if (response.data.resultStatus.messageCode !== '2000') {
          vm.resetStats()
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }

        vm.stats = response.data.resultData
        vm.setChartData(vm.stats.dailyStatList)

        // 목록은 통계가 확정한 적용기간을 기본값으로 쓰므로 응답을 받은 뒤에 읽는다.
        vm.refreshList()
      })
    },
    resetStats: function () {
      const vm = this

      vm.stats = vm.emptyStats()
      vm.setChartData([])
      vm.selectedYmd = ''
      vm.refreshList()
    },
    emptyStats: function () {
      return {
        totalCnt: 0,
        userCnt: 0,
        loginCnt: 0,
        errCnt: 0,
        avgProcMs: 0,
        searchStartYYYYMMDD: '',
        searchEndYYYYMMDD: '',
        dailyStatList: []
      }
    },
    setChartData: function (dailyStatList) {
      const vm = this

      const chartData = vm.toCategoryData(dailyStatList)

      vm.totalChartData = {
        series: {
          type: 'column',
          data: chartData,
          axis: vm.constant.totalAxis,
          visible: vm.totalChartData.series.visible !== false,
          categoryField: 'category',
          field: 'totalCnt',
          color: '#b7c3ff',
          tooltip: {
            visible: true,
            background: '#ffffff',
            template: `#= dataItem.MMdd # : 전체 #= kendo.format('{0:N0}', value) #건 &nbsp`
          }
        },
        valueAxis: {
          name: vm.constant.totalAxis,
          visible: true,
          ...vm.calcAxisRange(chartData, 'totalCnt'),
          labels: {
            position: 'start',
            template: `#= kendo.format('{0:N0}', value) # 건 `
          }
        }
      }

      vm.loginChartData = {
        series: {
          type: 'line',
          data: chartData,
          axis: vm.constant.loginAxis,
          visible: vm.loginChartData.series.visible !== false,
          categoryField: 'category',
          field: 'loginCnt',
          color: '#4b79d8',
          tooltip: {
            visible: true,
            background: '#ffffff',
            template: `#= dataItem.MMdd # : 로그인 #= kendo.format('{0:N0}', value) #건 &nbsp`
          }
        },
        valueAxis: {
          name: vm.constant.loginAxis,
          visible: true,
          ...vm.calcAxisRange(chartData, 'loginCnt'),
          labels: {
            position: 'end',
            template: `#= kendo.format('{0:N0}', value) # 건 `
          }
        }
      }
    },
    /**
     * 응답의 date(yyyy/MM/dd)로 차트 카테고리 라벨을 만든다.
     * 날짜가 30~366개까지 늘어날 수 있어 전부 'M/d' 로 찍으면 축이 겹친다.
     * 그래서 월이 바뀌는 날만 'M/d', 나머지는 'd' 로 표기한다.
     * (기존 통계화면 ReportLocationList 의 표기 규약과 동일)
     */
    toCategoryData: function (dailyStatList) {
      const list = Array.isArray(dailyStatList) ? dailyStatList : []

      return list.map((item, i) => {
        const parts = item.date.split('/')
        const prevParts = i === 0 ? null : list[i - 1].date.split('/')
        const isChangeMonth = i === 0 || parts[1] !== prevParts[1]

        return {
          ...item,
          category: isChangeMonth ? `${Number(parts[1])}/${Number(parts[2])}` : `${Number(parts[2])}`,
          MMdd: `${parts[1]}/${parts[2]}`
        }
      })
    },
    /**
     * 값축의 min / max / 구분선 간격을 계산한다.
     * 최대값을 그대로 max 로 쓰면 최고점 막대의 위쪽이 잘려 보이므로 한 단위 올림한다.
     * (기존 통계화면 ReportLocationList 의 계산식과 동일)
     */
    calcAxisRange: function (chartData, field) {
      if (!chartData.length) {
        return { min: 0, max: 5, majorUnit: 1 }
      }

      const maxCnt = chartData.reduce((prev, current) => (prev[field] > current[field] ? prev : current))[field]

      // 최대값이 5보다 작으면 보조값이 0 0 0 1 1 처럼 중복 표기된다.
      if (maxCnt < 5) {
        return { min: 0, max: 5, majorUnit: 1 }
      }

      const num = 10 ** (maxCnt.toString().length === 1 ? 1 : maxCnt.toString().length - 1)
      const max = Math.ceil(maxCnt * 1.001 / num) * num

      return { min: 0, max: max, majorUnit: max / 5 }
    },
    cleanSearchDataEvent: function () {
      const vm = this
      const refs = vm.$refs

      refs.cmpyCdRef?.widget().value('')
      refs.dtRef?.widget().range({ start: vm.defaultStartDate, end: new Date() })

      if (refs.userTextRef) { refs.userTextRef.value = '' }
      if (refs.acsIpRef) { refs.acsIpRef.value = '' }
      if (refs.reqUriRef) { refs.reqUriRef.value = '' }

      refs.taskTypeRef?.kendoWidget()?.value('')
      refs.errYnRef?.widget()?.select(0)

      vm.propsCmpyCd = ''
      vm.selectedYmd = ''
      vm.allApiCall()
    },
    /**
     * 엑셀 다운로드. 화면에 보이는 페이지가 아니라 현재 조회조건 전체를 내린다.
     * (requestType=EXPORT : 서버가 페이징 없이 조회한다)
     */
    onClickExcelDownload: function () {
      const vm = this

      const param = vm.listFilterParam()

      if (!param) {
        kendo.alert('회사를 먼저 선택해주세요.')
        return
      }

      /*
       * 접속기록은 API 호출마다 1행씩 쌓인다. 기간을 넓게 잡으면 수십만 행이 되어
       * 브라우저가 멈춘다. 요약 카드가 이미 건수를 알고 있으니 미리 확인을 받는다.
       * (일자를 선택한 상태면 하루치라 확인하지 않는다)
       */
      if (!vm.selectedYmd && vm.stats.totalCnt > vm.constant.excelConfirmCnt) {
        kendo.confirm(
            `조회된 접속기록이 ${EtnersCommonUtil.numberWithCommas(vm.stats.totalCnt)}건입니다.<br>`
            + '다운로드에 시간이 오래 걸릴 수 있습니다. 계속하시겠습니까?')
        .done(function () {
          vm.excelDownload(param)
        })
        return
      }

      vm.excelDownload(param)
    },
    excelDownload: function (param) {
      const vm = this

      ApiUtil.query(`${ApiConfig.fmsDomain}/fms/common/acs-log`, {
        ...param,
        requestType: 'EXPORT'
      })
      .then((response) => {
        if (response.data?.resultStatus === undefined) {
          kendo.alert('데이터가 정상적으로 조회되지 않았습니다.')
          return false
        }

        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }

        const resultData = response.data.resultData

        if (!EtnersCommonUtil.isNotEmpty(resultData) || resultData.length < 1) {
          kendo.alert('다운로드 할 자료가 없습니다.')
          return false
        }

        // 접속일시는 ISO 문자열이라 그대로 내리면 셀에 2026-09-17T13:24:05 로 박힌다.
        const excelRows = resultData.map(row => ({
          ...row,
          acsDtText: vm.toDisplayDateTime(row.acsDt)
        }))

        saveExcel({
          data: excelRows,
          fileName: '접속기록_' + EtnersDateTimeUtil.dateToYYYYMMDD(new Date()) + '.xlsx',
          columns: vm.excelColumns
        })
      })
    }
  },
  data () {
    const vm = this

    const constant = {
      total: '전체 접속',
      login: '로그인',
      totalAxis: 'TOTAL',
      loginAxis: 'LOGIN',
      // 엑셀 다운로드 전에 확인을 받기 시작하는 건수
      excelConfirmCnt: 50000
    }

    // 기본 조회기간은 최근 30일. 서버 기본값(DEFAULT_PERIOD_DAYS)과 맞춘다.
    const defaultStartDate = new Date()
    defaultStartDate.setDate(defaultStartDate.getDate() - 29)

    const headerAttributes = { style: 'font-weight: bold; text-align: center;' }
    const centerAttributes = { style: 'text-align: center;' }
    const rightAttributes = { style: 'text-align: right;' }
    // 요청 URI / 처리내역은 값이 길다. 줄바꿈되면 행 높이가 들쭉날쭉해져 목록을 훑기 어렵다.
    const ellipsisAttributes = {
      style: 'text-align: left; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;'
    }

    return {
      Constant,
      constant: constant,
      ApiConfig: ApiConfig,
      defaultStartDate: defaultStartDate,
      propsCmpyCd: '',
      chartTransitions: true,
      // 차트에서 클릭한 일자(yyyyMMdd). 값이 있으면 목록만 그 하루로 좁힌다.
      selectedYmd: '',
      isErrYnGroupMounted: false,
      lastListParams: {},
      // 수행업무 구분은 서버 enum(AcsTaskType)과 1:1 로 맞춘다. 코드마스터에는 없는 값이다.
      taskTypeList: [
        { cdId: 'LOGIN', cdNm: '로그인' },
        { cdId: 'LOGOUT', cdNm: '로그아웃' },
        { cdId: 'SELECT', cdNm: '조회' },
        { cdId: 'INSERT', cdNm: '등록' },
        { cdId: 'UPDATE', cdNm: '수정' },
        { cdId: 'DELETE', cdNm: '삭제' },
        { cdId: 'DOWNLOAD', cdNm: '다운로드' },
        { cdId: 'UPLOAD', cdNm: '업로드' },
        { cdId: 'OTHER', cdNm: '기타' }
      ],
      /*
       * 사용자명(userNm) / 수행업무 구분명(taskTypeNm) 은 로그 테이블 컬럼이 아니라
       * 서브쿼리와 enum 으로 만들어 붙이는 값이다. 서버 정렬 대상이 될 수 없어 sortable 을 끈다.
       */
      gridColumns: [
        {
          field: 'rowNumber',
          title: 'No',
          width: '4%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes,
          sortable: false
        },
        {
          field: 'acsDt',
          title: '접속일시',
          width: '11%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes,
          template: function (dataItem) {
            return vm.toDisplayDateTime(dataItem.acsDt)
          }
        },
        {
          field: 'userId',
          title: '계정',
          width: '12%',
          headerAttributes: headerAttributes,
          attributes: ellipsisAttributes,
          template: function (dataItem) {
            return vm.cellWithTooltip(dataItem.userId,
                `${dataItem.userId ?? ''}\n고유 사용자 ID : ${dataItem.unqUserId ?? '-'}`)
          }
        },
        {
          field: 'userNm',
          title: '사용자명',
          width: '8%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes,
          sortable: false,
          template: function (dataItem) {
            return dataItem.userNm ? dataItem.userNm : '-'
          }
        },
        {
          field: 'taskTypeNm',
          title: '수행업무',
          width: '6%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes,
          sortable: false
        },
        {
          field: 'taskNm',
          title: '처리내역',
          width: '17%',
          headerAttributes: headerAttributes,
          attributes: ellipsisAttributes,
          template: function (dataItem) {
            return vm.cellWithTooltip(dataItem.taskNm)
          }
        },
        {
          field: 'reqMethod',
          title: '메소드',
          width: '5%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes
        },
        {
          field: 'reqUri',
          title: '요청 URI',
          width: '15%',
          headerAttributes: headerAttributes,
          attributes: ellipsisAttributes,
          template: function (dataItem) {
            // 요청 파라미터는 컬럼으로 두면 목록이 읽히지 않는다. URI tooltip 으로 함께 보여준다.
            return vm.cellWithTooltip(dataItem.reqUri,
                `${dataItem.reqUri ?? ''}\n요청 파라미터 : ${dataItem.reqParam ?? '-'}`)
          }
        },
        {
          field: 'acsIp',
          title: '접속 IP',
          width: '9%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes,
          template: function (dataItem) {
            return vm.cellWithTooltip(dataItem.acsIp,
                `${dataItem.acsIp ?? ''}\n접속 환경 : ${dataItem.acsBrowser ?? '-'}`)
          }
        },
        {
          field: 'procMs',
          title: '처리시간',
          width: '7%',
          headerAttributes: headerAttributes,
          attributes: rightAttributes,
          template: function (dataItem) {
            return dataItem.procMs === null || dataItem.procMs === undefined
                ? '-'
                : `${EtnersCommonUtil.numberWithCommas(dataItem.procMs)} ms`
          }
        },
        {
          field: 'errYn',
          title: '결과',
          width: '6%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes,
          template: function (dataItem) {
            const httpStatus = dataItem.httpStatus ?? '-'

            if (dataItem.errYn === 'Y') {
              return vm.cellWithTooltip(`오류(${httpStatus})`,
                  `결과코드 : ${dataItem.resultCd ?? '-'}\n오류 메시지 : ${dataItem.errMsg ?? '-'}`)
            }

            return vm.cellWithTooltip(`정상(${httpStatus})`,
                `결과코드 : ${dataItem.resultCd ?? '-'}\n결과 메시지 : ${dataItem.resultMsg ?? '-'}`)
          }
        }
      ],
      // 엑셀은 화면에서 접어둔 값(요청 파라미터 / 접속 환경 / 오류 메시지)까지 모두 내린다.
      excelColumns: [
        { field: 'acsDtText', title: '접속일시', width: '140px' },
        { field: 'userId', title: '계정', width: '170px' },
        { field: 'unqUserId', title: '고유 사용자 ID', width: '130px' },
        { field: 'userNm', title: '사용자명', width: '90px' },
        { field: 'taskTypeNm', title: '수행업무', width: '80px' },
        { field: 'taskNm', title: '처리내역', width: '260px' },
        { field: 'reqMethod', title: '메소드', width: '70px' },
        { field: 'reqUri', title: '요청 URI', width: '220px' },
        { field: 'reqParam', title: '요청 파라미터', width: '300px' },
        { field: 'acsIp', title: '접속 IP', width: '110px' },
        { field: 'acsBrowser', title: '접속 환경', width: '260px' },
        { field: 'procMs', title: '처리시간(ms)', width: '90px' },
        { field: 'httpStatus', title: 'HTTP 상태', width: '80px' },
        { field: 'resultCd', title: '결과코드', width: '80px' },
        { field: 'resultMsg', title: '결과 메시지', width: '220px' },
        { field: 'errYn', title: '오류여부', width: '70px' },
        { field: 'errMsg', title: '오류 메시지', width: '300px' }
      ],
      stats: {
        totalCnt: 0,
        userCnt: 0,
        loginCnt: 0,
        errCnt: 0,
        avgProcMs: 0,
        searchStartYYYYMMDD: '',
        searchEndYYYYMMDD: '',
        dailyStatList: []
      },
      totalChartData: {
        series: {},
        valueAxis: {}
      },
      loginChartData: {
        series: {},
        valueAxis: {}
      }
    }
  },
  mounted () {
    // 회사 드롭다운이 default-index 0 으로 첫 회사를 선택하면서 change 를 쏘지만,
    // 선택 가능한 회사가 없는 계정은 change 가 오지 않으므로 빈 상태를 명시적으로 그려둔다.
    this.setChartData([])
  }
}
</script>

<style scoped>
/*
 * 공통 CSS(ebmp.css / fms.css)는 원격 디자인 서버에서 로드되므로 이 화면에서 클래스를 추가할 수 없다.
 * 컨테이너(contents_wrap / small_title_wrap / box_flex)는 공통 클래스를 그대로 쓰고,
 * 요약 카드의 숫자 표기만 이 화면에서 정의한다.
 */
.acs_stat_value {
  margin: 14px 0 4px;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  text-align: right;
  word-break: break-all;
}

.acs_stat_value.blue { color: #4b79d8; }
.acs_stat_value.green { color: #008b14; }
.acs_stat_value.red { color: #d63031; }
.acs_stat_value.gray { color: #555555; }

.acs_stat_unit {
  margin-left: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #888888;
}

.acs_stat_desc {
  margin-bottom: 6px;
  font-size: 12px;
  color: #888888;
  text-align: right;
}

.acs_stat_period {
  margin-left: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #888888;
}

.acs_list_scope {
  display: inline-block;
  padding: 6px 0;
  font-size: 13px;
  color: #555555;
}
</style>
